var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrap"},[_c('img',{attrs:{"src":require("@/assets/images/img_empty.png")}}),_c('p',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }